import moment from "moment"

const initialState = {
  drawerOpen: true,
  notificationsChanged: null
}

const uiReducer = (state = initialState, action) => {
  const newState = { ...state }

  switch (action.type) {
    case 'DRAWER_OPEN':
      newState.drawerOpen = true
    
    case 'NOTIFICATION_CHANGED':
      newState.notificationsChanged = moment()

      return newState
    case 'DRAWER_CLOSE':
        newState.drawerOpen = false
  
        return newState
    default:
      return state
  }
}

export default uiReducer
